import { useTu } from "@src/appV2/i18n/useTu";
import BlockIcon from "@mui/icons-material/Block";
import { Box } from "@mui/material";
import { Text } from "../../components/Text";

export interface ChatDeactivatedStateProps {
  workerName: string;
}

export function ChatDeactivatedState(props: ChatDeactivatedStateProps) {
  const { tu } = useTu("chat");

  const { workerName } = props;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 4,
        gap: 2,
        textAlign: "center",
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.borderRadius?.medium,
      })}
    >
      <BlockIcon
        sx={(theme) => ({
          fontSize: "32px",
          color: theme.palette.text.secondary,
        })}
      />
      <Box>
        <Text
          semibold
          variant="body1"
          sx={(theme) => ({
            color: theme.palette.text.primary,
            marginBottom: 1,
          })}
        >
          {tu("Chat Unavailable")}
        </Text>
        <Text
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
          })}
        >
          {tu(
            "{{workerName}}'s account has been deactivated and can no longer send or receive messages.",
            {
              values: { workerName },
            }
          )}
        </Text>
      </Box>
    </Box>
  );
}
